module.exports = __webpack_public_path__ + "static/media/doctor.15b3091a.png";